var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_vm._t("mastheadOverride",[_c('div',{staticClass:"masthead",style:({backgroundImage: 'url('+_vm.mastheadBackgroundImage+')'})},[_c('div',{staticClass:"masthead__inner"},[_vm._t("masthead")],2)])]),_vm._v(" "),_c('div',{staticClass:"lower"},[_c('div',[_vm._t("body")],2)]),_vm._v(" "),_c('div',{staticClass:"footer"},[_vm._t("footer")],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-058c1654","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/layoutA/index.vue
// module id = null
// module chunks = 